'use strict';
import React from 'react';
import flux from 'utils/flux';
import { RouteHandler, Link } from 'react-router';
import HeaderSearch from 'components/headerBar/headerSearch';
import AltContainer from 'alt-container';

var AccountPage = React.createClass({
    displayName: 'AccountPage',
    mixins: [],
    propTypes: {},
    statics: {
        willTransitionTo: function(transition) {
            if (!flux.getStore('app').isAuthenticated()) {
                transition.redirect('/login', {}, {nextPath: transition.path});
            }
            if (!flux.getStore('app').hasAcceptedLatestTerms()) {
                transition.redirect('/accept_terms', {}, {nextPath: transition.path});
            }
        }
    },
    render() {
        const { accountEditable, passwordEditable, config } = flux.getStore('app').getState();
        const { disableChangePassword, disableAccountDetails } = config.toJS();

        return (
            <div className="page account">

                <div className="headerbar">
                    <div className="container--centered">
                        <HeaderSearch/>
                    </div>
                </div>

                <div className="account__container container--centered">
                    <div className="container__navigation">
                        <ul>
                            {false !== accountEditable && !disableAccountDetails &&
                                <li><Link to="accountDetails">{flux.t('account_details')}</Link></li>
                            }
                            {false !== passwordEditable && !disableChangePassword &&
                                <li><Link to="accountPassword">{flux.t('account_password_change_head')}</Link></li>
                            }
                            <li><a href="/#/terms-of-use" target="_blank">{flux.t('terms-of-use')}</a></li>
                        </ul>
                        <Link to="landing-page" className="navigation__back">
                            <i className="chevron-left"/>
                            {flux.t('back_to_home')}
                        </Link>
                    </div>
                    <div className="container__content">
                        {false !== accountEditable && <AltContainer stores={{appStore: flux.getStore('app')}}>
                            <RouteHandler {...this.props} />
                        </AltContainer>}
                    </div>
                </div>
            </div>
        );
    }
});

module.exports = AccountPage;



// WEBPACK FOOTER //
// ./app/pages/account/index.jsx